import { colors } from 'theme'

export const defaultThemeStyles = {
    selected: colors.selected,
    activeBackground: colors.darkBlue,
    background: colors.white,
}
